export default "__VITE_ASSET__86d02cfd__"